export default __webpack_public_path__ + "static/media/hero_id_2.0a6f72ca.jpg";